/**
 * Main App component with routing and authentication.
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { PortfolioProvider } from './contexts/PortfolioContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';
import { theme } from './theme/theme';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { PositionsPage } from './pages/PositionsPage';
import { RecommendationsPage } from './pages/RecommendationsPage';
import { ConfigPage } from './pages/ConfigPage';
import { HistoryPage } from './pages/HistoryPage';
import { PortfolioDetailsPage } from './pages/PortfolioDetailsPage';
import { validateConfig } from './config/env';
import { configureAmplify } from './config/amplify';

// Validate environment configuration
try {
  validateConfig();
} catch (error) {
  console.error('Configuration error:', error);
}

// Configure Amplify
try {
  configureAmplify();
  console.log('Amplify configured successfully');
} catch (error) {
  console.error('Failed to configure Amplify:', error);
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <PortfolioProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <DashboardPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/positions"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <PositionsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/recommendations"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <RecommendationsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/recommendations/:id"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <RecommendationsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/config"
              element={
                <ProtectedRoute requireAdmin>
                  <AppLayout>
                    <ConfigPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <HistoryPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/portfolio/:portfolioId"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <PortfolioDetailsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </PortfolioProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
